import { IRoute } from "src/pages/Router/routes";

import OrderSettingsPage from "./OrderSettings";
import LogoColorsFontPage from "./LogoColorsFontPage";
import MaintenanceSettingsPage from "./MaintenanceSettingsPage";
import SupportSettingsPage from "./SupportSettings";
import CreditRequestSettings from "./CreditRequestSettings";
import ProcessJobSchedulePage from "./ProcessJobScheduleSettings";
import ProcessJobsQueuePage from "./ProcessJobQueue/ProcessJobQueuePage";
import ViewQueueJobPage from "./ProcessJobQueue/ViewQueueJobPage";

const AdminSettings: IRoute[] = [
  {
    exact: true,
    path: "/platform/defaults",
    title: "Order settings",
    pageComponent: OrderSettingsPage,
    menuType: "ADMIN_SETTINGS",
    context: "PLATFORM_SETTINGS",
    privateRoute: true,
    permissions: [ "view-global-settings" ]
  },
  {
    exact: true,
    path: "/platform/lead-times",
    title: "Lead Times",
    menuType: "ADMIN_SETTINGS",
    context: "PLATFORM_SETTINGS",
    privateRoute: true,
    permissions: [ "view-global-settings" ]
  },
  {
    exact: true,
    path: "/platform/support",
    title: "Support settings",
    pageComponent: SupportSettingsPage,
    menuType: "ADMIN_SETTINGS",
    context: "PLATFORM_SETTINGS",
    privateRoute: true,
    permissions: [ "view-global-settings" ],
    modules: [ "support" ]
  },
  {
    exact: true,
    path: "/platform/shutdowns",
    title: "Shutdowns",
    menuType: "ADMIN_SETTINGS",
    context: "PLATFORM_SETTINGS",
    privateRoute: true,
    permissions: [ "view-global-settings" ]
  },
  {
    exact: true,
    path: "/platform/logo-colours-font",
    title: "Logo, colours & font",
    pageComponent: LogoColorsFontPage,
    menuType: "ADMIN_SETTINGS",
    context: "PLATFORM_SETTINGS",
    permissions: [ "amend-global-settings" ],
    roles: [ "admin" ],
    privateRoute: true
  },
  {
    exact: true,
    path: "/platform/maintenance",
    title: "Maintenance",
    pageComponent: MaintenanceSettingsPage,
    menuType: "ADMIN_SETTINGS",
    context: "PLATFORM_SETTINGS",
    privateRoute: true,
    permissions: [ "amend-global-settings" ],
    roles: [ "admin" ]
  },
  {
    exact: true,
    path: "/platform/credit-request-settings",
    title: "Credit request settings",
    pageComponent: CreditRequestSettings,
    menuType: "ADMIN_SETTINGS",
    context: "PLATFORM_SETTINGS",
    privateRoute: true,
    permissions: [ "amend-global-settings" ],
    modules: [ "credit-request" ]
  },
  {
    exact: true,
    path: "/platform/process-job-schedule-settings",
    title: "Scheduled Jobs",
    pageComponent: ProcessJobSchedulePage,
    menuType: "ADMIN_SETTINGS",
    context: "PLATFORM_SETTINGS",
    privateRoute: true,
    roles: [ "admin" ],
    permissions: [ "amend-process-jobs-schedule" ]
  }
];

const ProcessJobRoutes: IRoute[] = [
  {
    exact: true,
    path: "/platform/process-job-queue",
    title: "Jobs Queue",
    pageComponent: ProcessJobsQueuePage,
    menuType: "ADMIN_SETTINGS",
    context: "PLATFORM_SETTINGS",
    privateRoute: true,
    roles: [ "admin" ],
    permissions: [ "view-process-jobs" ]
  }
];

const ProcessJobNestedRoutes: IRoute[] = [
  {
    exact: true,
    path: "/platform/process-job-queue/:processJobId",
    pageComponent: ViewQueueJobPage,
    title: "Queue Job",
    hidden: true,
    menuType: "EMPTY",
    privateRoute: true,
    parent: ProcessJobRoutes[ 0 ],
    roles: [ "admin" ]
  }
];

export default [
  ...AdminSettings,
  ...ProcessJobRoutes,
  ...ProcessJobNestedRoutes
];
